const BLUE   = 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200'
const ORANGE = 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-200'
const GREEN  = 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-200'
const RED    = 'bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-300'
const GRAY   = 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'

const COLOR_MAP = {
  blue:   BLUE,
  orange: ORANGE,
  green:  GREEN,
  red:    RED,
  gray:   GRAY,
}

// Thin adapter — stage label, detail, and card_action come from the API.
// This module only owns the visual badge color mapping.

export function stageInfo(row) {
  return {
    label:      row.stage       ?? '',
    detail:     row.stage_detail ?? null,
    badgeClass: COLOR_MAP[row.stage_color] ?? GRAY,
  }
}

export function cardAction(row) {
  return row.card_action ?? null
}

export function isClosed(row) {
  return row.is_closed ?? false
}
